import { render, staticRenderFns } from "./DocumentDraftingSignProcess.vue?vue&type=template&id=44887e7e&scoped=true"
import script from "./DocumentDraftingSignProcess.vue?vue&type=script&lang=js"
export * from "./DocumentDraftingSignProcess.vue?vue&type=script&lang=js"
import style0 from "./DocumentDraftingSignProcess.vue?vue&type=style&index=0&id=44887e7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44887e7e",
  null
  
)

export default component.exports